









import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import {enumTextFromValue} from "@/helpers/functions_asi";
import AsiCardDetail from "../common/AsiCardDetail.vue";
import User from "@/models/user/User";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import {UserState} from "@/helpers/constants";

@Component({
	components: {AsiCardDetailEntry, AsiCardDetail}
})
export default class UserCardSettings extends Vue {

	@Prop({type: Object, default: null})
	public user!: User | null;

	private icons = Icon;

	private get userStateLabel(): string | null {
		return enumTextFromValue(UserState, this.user?.state ?? null, true);
	}

}
